<div class="form-group">
  <label [for]="id" *ngIf="label">{{ label }}</label>
  <div class="input-group">
    <input
      [id]="id"
      [value]="displayValue"
      (input)="onInputChange($event)"
      (blur)="onInputBlur()"
      (focus)="onInputFocus($event)"
      class="form-control"
      [placeholder]="placeholder"
      [disabled]="disabled"
      inputmode="decimal"
      pattern="[0-9.,]*"
    />
    <div class="input-group-append">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="toggleDecimals()"
        [disabled]="disabled"
        [ngbTooltip]="tooltipText"
      >
        <i class="fa-solid" [ngClass]="showFull ? 'fa-down-left-and-up-right-to-center' : 'fa-up-right-and-down-left-from-center'"></i>
      </button>
    </div>
  </div>
</div>
